(function() {
    angular
        .module("loginModule")
        .controller("UserConfirmationController", UserConfirmationController)

    UserConfirmationController.$inject = [
        "$stateParams",
        "$state",
        "$rootScope",
        "$scope",
        "authenticationService",
        "usersService",
        "userMessagingService"
    ]

    function UserConfirmationController(
        $stateParams,
        $state,
        $rootScope,
        $scope,
        authenticationService,
        usersService,
        userMessagingService
    ){
        "use strict"

        authenticationService.logoutSoft()

        /**
            $rootScope variables
         **/
        $rootScope.title = "Confirm User | WANCO"

        /**
            $scope variables
         **/
        $scope.userConfirmationFormData = {}

        /**
            Check password match
         **/
        $scope.checkPasswordMatch = function() {
            $scope.passwordMatch = $scope.userConfirmationFormData.password_confirmation == $scope.userConfirmationFormData.password
        }

        /**
            Confirm user
         **/
        $scope.confirmUser = function() {
            $scope.submitted = true
            $scope.formSuccess = false
            if ($scope.userConfirmationFormData.password_confirmation !== $scope.userConfirmationFormData.password) {
                $scope.passwordMatch = false
                $scope.userConfirmationForm.$valid = false
            } else {
                $scope.passwordMatch = true
            }
            if ($scope.userConfirmationForm.$valid) {

                var success = function() {
                    $state.go("login").then(() => {
                        userMessagingService.success("User Confirmation Successful: You may now log in.")
                    })
                }

                var failure = function(error) {
                    var alertMessage = "Confirmation Failure: Unknown Internal Error"
                    if (error !== undefined) {
                        if (error.hasOwnProperty("confirmation_token") && error.confirmation_token.length > 0) {
                            alertMessage = "Confirmation Failure: Token " + error.confirmation_token[0]
                        } else if (error.hasOwnProperty("email") && error.email.length > 0) {
                            alertMessage = "Confirmation Failure: Email " + error.email[0]
                        } else if (error.hasOwnProperty("password") && error.password.length > 0) {
                            alertMessage = "Confirmation Failure: Password " + error.password[0]
                        } else {
                            console.error(error)
                        }
                    }
                    userMessagingService.error(alertMessage)
                }

                usersService.confirmUser(angular.fromJson($scope.userConfirmationFormData), $stateParams.confirmation_token, success, failure)

            }
        }
    }
})()
